module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/CK-89183b8b378dd06a639ccd58de279cfb.png";